import { render, staticRenderFns } from "./gzzoc-elderly-cataract-pdf.vue?vue&type=template&id=90d47ee8&scoped=true&lang=pug&"
import script from "./gzzoc-elderly-cataract-pdf.vue?vue&type=script&lang=js&"
export * from "./gzzoc-elderly-cataract-pdf.vue?vue&type=script&lang=js&"
import style0 from "./gzzoc-elderly-cataract-pdf.vue?vue&type=style&index=0&id=90d47ee8&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90d47ee8",
  null
  
)

export default component.exports